// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2geXu","head":"ProcedureTableInfo_head__2T5Ej"};